import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8V1L7 6z"
}), 'ReplayTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ReplayTwoTone.js
// module id = 5772
// module chunks = 2